import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import { makeStyles } from "@material-ui/core/styles";
import { Menu, Dropdown, Affix,Button, Modal, Form, Input, notification } from "antd";
import { decode as tokenDecoder } from "../utils/tokenDecoder";
import { Link, NavLink, useHistory } from "react-router-dom";
import { DownOutlined, LoginOutlined } from "@ant-design/icons";
import logo from "../assets/images/shecancode/logo.png";

import LoginForm from"../components/common/LoginForm";

import { loginAction } from "../redux/actions/authActions";

import { TRANSPARENT_COLOR, ORANGE_LIKE_COLOR } from "../utils/colors";
const { Search } = Input;
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  toolbarTop: {
    minHeight: 70,
    display: "block",
    backgroundColor: "#fff",
    opacity: 1,
    boxShadow: "2px 2px #00F0FF",
  },
  navItem: {
    marginTop: 15,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
}));

const LandingPageAppBar = ({ loginAction, auth }) => {
  const classes = useStyles();
  const history = useHistory();

  const token = localStorage.getItem("x-auth-token");
  const userData = token && tokenDecoder(token);

  console.log("userData:>>>",userData);

  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };
  const onSearch = value => console.log(value);
  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const [loading, setLoading] = useState(false);

  const onFinish = (values) => {
    setLoading(true);
    loginAction(values);
    // dispatch({ type: LOGIN, payload: values });
  };

  useEffect(() => {
    if (auth.login.loginData) {
      notification.success({ message: auth.login.loginData?.message });
      const token = localStorage.getItem("x-auth-token");
      const { role, firstName } = tokenDecoder(token);
      role === "admin" ? history.push("/dashboard") : history.push("/home");
      window.location.reload();
      setLoading(false);
    }
    if (auth.login.loginError) {
      notification.error({ message: auth.login.loginError?.error });
      setLoading(false);
    }
  }, [auth.login.loginData, auth.login.loginError]);

  const logout = () => {
    localStorage.removeItem("x-auth-token");
    history.push("/land");
    window.location.reload();
  };

  const menu = (
    <Menu>
      {token && userData.role === "admin" && (
        <Menu.Item>
          <Link to="/dashboard">Admin dashboard</Link>
        </Menu.Item>
      )}
      <Menu.Item>
        <Link to="/account/settings">My Profile</Link>
      </Menu.Item>
      <Menu.Item onClick={logout}>
        <Link to="#">Logout</Link>
      </Menu.Item>
    </Menu>
  );

  return (
    <>
    <Affix offsetTop={0}>
  
      <div className={classes.root}>
        <AppBar position="static">
          <Toolbar className={classes.toolbarTop}>
            <div className={classes.navItem}>
              <Link to="/land">
                <img src={logo} alt="logo" width="250" />
              </Link>
              {/* <label
                style={{
                  color: "#038585",
                  fontSize: "34px",
                  fontWeight: "bold",
                }}
              >
                <span style={{ color: "black" }}> SheCan</span>
                <span style={{ color: "#00cedd" }}>Code </span> Materials
              </label> */}
              
              <Search placeholder="search course / Mentor name" allowClear onSearch={onSearch}  style={{width:"30%",margin:"15px 0px 0px 0px"}}/>




              {token ? (
                <Dropdown overlay={menu} placement="bottomLeft" arrow>
                  <label
                    style={{
                      color: "#038585",
                      fontSize: "20px",
                      marginTop: "5px",
                      fontWeight: "300",
                    }}
                  >
                    {userData.firstName} {userData.lastName} <DownOutlined />
                  </label>
                </Dropdown>
              ) : (
                <Link onClick={showModal} to="/">
                  <div
                    style={{
                      background: "#038585",
                      color: "#ffffff",
                      fontSize: "27px",
                      fontWeight: "bolder",
                      cursor: "pointer",
                      padding: "5px 10px 5px 0px",
                    }}
                  >
                    <LoginOutlined />
                    <label style={{ marginLeft: "5px", cursor: "pointer" }}>
                      Login
                    </label>
                  </div>
                </Link>
              )}
            </div>
          </Toolbar>
        </AppBar>
      </div>
      <Modal
        title="SheCanCode Materials"
        visible={isModalVisible}
        okButtonProps={{ disabled: true,ghost:true }}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <LoginForm/>
      </Modal>    
    </Affix>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

export default connect(mapStateToProps, { loginAction })(LandingPageAppBar);
